import { Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BADGE_PAPER_STYLES } from "../../_app/consts";
import Loading from "../Loading";
import { SeverityBotColors } from "./types";
import { BotSeverity } from "../../_app/types";
import { myT } from "../../_i18n/utils";

const getBadgeText = (severity: BotSeverity): string => {
  switch (severity) {
    case "RUNNING":
      return myT("running", "botsList");
    case "UNSUCCESSFUL_START":
      return myT("startFailure", "botsList");
    case "OPENING":
      return myT("opening", "botsList");
    case "ERROR":
      return myT("error", "botsList");
    case "CLOSING":
      return myT("closing", "botsList");
    case "WAITING_TO_BE_CLOSED":
      return myT("closing", "botsList");
    case "NO_LOSS_CLOSING":
      return myT("noLossClosing", "botsList");
    case "SHUTDOWN":
      return myT("shutdown", "botsList");
    default:
      return "";
  }
};

interface BadgeStatusProps {
  severity: BotSeverity;
}

const textColor = (severity: BotSeverity, mode: "dark" | "light") => {
  if (mode === "dark") {
    return ["SHUTDOWN", "UNSUCCESSFUL_START", "ERROR"].includes(severity ?? "") ? "white" : "#000";
  } else {
    return ["SHUTDOWN", "UNSUCCESSFUL_START", "ERROR"].includes(severity ?? "") ? "white" : "#000";
  }
};

const BadgeStatus = ({ severity }: BadgeStatusProps) => {
  const theme = useTheme();
  const typographyColor = textColor(severity, theme.palette.mode);

  return (
    <Paper
      elevation={0}
      sx={{
        ...BADGE_PAPER_STYLES,
        backgroundColor: severity ? SeverityBotColors[severity] : "transparent",
      }}
    >
      <Typography sx={{ fontSize: "10px" }} variant={"body2"} color={typographyColor}>
        {severity ? getBadgeText(severity) : <Loading size={20} />}
      </Typography>
    </Paper>
  );
};

export default BadgeStatus;
